import { Alert, AlertTitle } from "@mui/material";

import type { ReactNode } from "react";

export type FormErrorBannerProps = {
    show?: boolean;
    /** A single message/node, or a list of messages rendered as bullets. */
    message?: ReactNode | string[];
};

export default function FormErrorBanner({ show, message }: FormErrorBannerProps) {
    if (!show) return null;

    if (Array.isArray(message)) {
        return <Alert severity="error" variant="outlined">
            <AlertTitle>Error:</AlertTitle>
            <ul>
                { message.map((m, i) => <li key={ i }>{ m }</li>) }
            </ul>
        </Alert>;
    }

    return <Alert severity="error" variant="outlined">
        <AlertTitle>Error:</AlertTitle>
        { message }
    </Alert>;
}
